import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import FormRow from "@eres/forms-web/FormRow";
import Context from "../../Context";
import { HTRoleType } from "../../api/entities";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import eidConverter from "@eres/forms/converters/EidConverter";
import EidInputField from "@eres/forms-web/EidInputField";

interface Props {
	mode: "edit" | "view";
}

interface State {
	contractNo?: string;
	ownerName?: string;
	ownerEid?: string;
	tenantName?: string;
	tenantEid?: string;
}

class PersonInfo extends Component<Props, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	componentDidMount() {
		const { request } = this.context;
		const owner = request?.Parties.find( party => party.RoleId === HTRoleType.OWNER );
		const tenant = request?.Parties.find( party => party.RoleId === HTRoleType.TENANT );
		this.setState( {
			contractNo: request?.ContractNumber,
			ownerName: getLocalValue( { en: owner?.PartNameEn, ar: owner?.PartNameAr } ),
			ownerEid: owner?.EmiratesId,
			tenantName: getLocalValue( { en: tenant?.PartNameEn, ar: tenant?.PartNameAr } ),
			tenantEid: tenant?.EmiratesId,
		} );
	}

	render() {
		if ( this.props.mode === "view" ) {
			return <RenderInfo state={ this.state }/>;
		}
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group field-style",
			disabled: true,
		};
		return <div className="card mb-3">
			<div className="card-header">
				<span>{ Strings.contract_parties_information }</span>
			</div>
			<div className="card-body">
				<FormRow { ...filedProps }>
					<TextInputField
						id={ "contractNo" }
						label={ Strings.ejari_contract_number }/>
					<TextInputField
						id={ "ownerName" }
						label={ Strings.landlord_name }/>
					<EidInputField
						id={ "ownerEid" }
						label={ Strings.landlord_eid }
						valueConverter={ eidConverter }/>
					<TextInputField
						id={ "tenantName" }
						label={ Strings.tenant_name }/>
					<EidInputField
						id={ "tenantEid" }
						label={ Strings.tenant_emirates_id }
						valueConverter={ eidConverter }/>
				</FormRow>
			</div>
		</div>;
	}
}

function RenderInfo( props: { state: State } ) {
	const { contractNo, ownerName, ownerEid, tenantName, tenantEid } = props.state;
	return <>
		<div className="section-title">
			<h5>{ Strings.person_information }</h5>
		</div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.ejari_contract_number }</span>
				<span>{ contractNo }</span>
			</div>
			<div>
				<span>{ Strings.landlord_name }</span>
				<span>{ ownerName }</span>
			</div>
			<div>
				<span>{ Strings.landlord_eid }</span>
				<span>{ ownerEid }</span>
			</div>
			<div>
				<span>{ Strings.tenant_name }</span>
				<span>{ tenantName }</span>
			</div>
			<div>
				<span>{ Strings.tenant_emirates_id }</span>
				<span>{ tenantEid }</span>
			</div>
		</div>
	</>;
}

export default PersonInfo;
